var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "value": _vm.dialog,
      "max-width": "60%",
      "persistent": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline accent--text pb-4"
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? 'Редактировать' : 'Создать') + " ")]), _c('v-card-text', {
    staticClass: "border-top pt-6 pb-0",
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.speciality,
      "auto-select-first": "",
      "item-text": "name",
      "label": "Специальность",
      "placeholder": "Выберите из списка",
      "rounded": "",
      "outlined": "",
      "dense": "",
      "return-object": "",
      "error-messages": _vm.errorMessages.speciality
    },
    on: {
      "input": function input($event) {
        return _vm.$v.vacancy.speciality.$touch();
      },
      "blur": function blur($event) {
        return _vm.$v.vacancy.speciality.$touch();
      }
    },
    model: {
      value: _vm.vacancy.speciality,
      callback: function callback($$v) {
        _vm.$set(_vm.vacancy, "speciality", $$v);
      },
      expression: "vacancy.speciality"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.courseNumber,
      "auto-select-first": "",
      "item-text": "name",
      "label": "Номер курса",
      "placeholder": "Выберите из списка",
      "rounded": "",
      "outlined": "",
      "dense": "",
      "return-object": "",
      "error-messages": _vm.errorMessages.courseNumber
    },
    on: {
      "input": function input($event) {
        return _vm.$v.vacancy.courseNumber.$touch();
      },
      "blur": function blur($event) {
        return _vm.$v.vacancy.courseNumber.$touch();
      }
    },
    model: {
      value: _vm.vacancy.courseNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.vacancy, "courseNumber", $$v);
      },
      expression: "vacancy.courseNumber"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.paidForm,
      "auto-select-first": "",
      "item-text": "name",
      "label": "Тип обучения",
      "placeholder": "Выберите из списка",
      "rounded": "",
      "outlined": "",
      "dense": "",
      "return-object": "",
      "error-messages": _vm.errorMessages.paidForm
    },
    on: {
      "input": function input($event) {
        return _vm.$v.vacancy.paidForm.$touch();
      },
      "blur": function blur($event) {
        return _vm.$v.vacancy.paidForm.$touch();
      }
    },
    model: {
      value: _vm.vacancy.paidForm,
      callback: function callback($$v) {
        _vm.$set(_vm.vacancy, "paidForm", $$v);
      },
      expression: "vacancy.paidForm"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '####',
      expression: "'####'"
    }],
    attrs: {
      "label": "Мест",
      "placeholder": "Введите место",
      "rounded": "",
      "outlined": "",
      "dense": "",
      "error-messages": _vm.errorMessages.quantity
    },
    on: {
      "change": function change($event) {
        return _vm.$v.vacancy.quantity.$touch();
      },
      "blur": function blur($event) {
        return _vm.$v.vacancy.quantity.$touch();
      }
    },
    model: {
      value: _vm.vacancy.quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.vacancy, "quantity", $$v);
      },
      expression: "vacancy.quantity"
    }
  })], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "px-6"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "lightGrey"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Закрыть")]), _c('v-btn', {
    attrs: {
      "loading": _vm.saveBtnLoading,
      "disabled": _vm.$v.$invalid,
      "color": "success",
      "text": ""
    },
    on: {
      "click": _vm.saveVacancy
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? 'Редактировать' : 'Создать') + " ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }